import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'numeric-input',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumericInput),
      multi: true,
    },
  ],
})
export class NumericInput implements ControlValueAccessor {
  @Input() prefix: string | undefined;
  @Input() min: number | undefined;

  val: number | undefined;
  set value(value: number) {
    this.val = value;
    this.onChange(value);
    this.onTouch(value);
  }
  get value() {
    return this.val;
  }

  onChange: any = () => {};
  onTouch: any = () => {};

  constructor() {}

  decreaseOne() {
    if (this.val > this.min) {
      this.writeValue(this.val - 1);
    }
  }

  increaseOne() {
    this.writeValue(this.val + 1);
  }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    let newValue = Number(input.value);

    if (isNaN(newValue) || newValue < this.min) {
      newValue = 0;
    }

    this.value = newValue;
    input.value = String(newValue);
  }
}
